import React, { useContext, useEffect, useRef, useState } from 'react'
import moment from 'moment';
import 'moment-timezone';
import 'moment-duration-format';
import styles from './OtherConversations.module.css'
import { getCookie } from '../../utils/common'
import { zendeskTicketDetailsAPI } from '../../services/api/zendesk-ticket-details'
import Spinner from '../UI/Spinner'
import { Link } from 'react-router-dom';
import { AuthContext } from '../../store/auth-context';
import { URL } from '../../constants';


const OtherConversations = (props: any) => {

    const authCtx = useContext(AuthContext)

    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState('')
    const [data, setData] = useState<{[key: string]: any}>({})

    useEffect(()=> {
        getConversations()
    }, [])

    const getConversations = () => {
		setError('')
		setIsLoading(true)
        const tenantSlug = getCookie('current_tenant')
        zendeskTicketDetailsAPI(tenantSlug).getSingle?.(props.threadID)
            .then((response) => {
				setIsLoading(false)
				setData(response)
            })
            .catch((err: any) => {
				setIsLoading(false)
                if (err.response) {
                    console.log(err)
					setError(err?.response?.statusText || 'Not Found!')
                } else if (err?.request?.statusText) {
                    console.log(err.request)
					setError(err?.request?.statusText || 'Not Found!')
                } else {
                    console.log(err)
					setError("Not Found!")
                }
            })
    }

    const list = data.conversations && data.conversations?.length && data.conversations.map((conversation: any, idx: number) => {
		let sessionId = conversation.session_id ? `?session_id=${conversation.session_id}` : ''
        let isCurrentConversation = ((props.threadID + props.sessionID) == (props.threadID + conversation.session_id))
		return 	<li key={`conversation-${props.ticketIdx}-${idx}`} className={isCurrentConversation ? styles.active : ''}>
					<div className={`${styles.sessionDetails}`}>
						<div>{(conversation.session_id && conversation.session_id != 'null') ? 'Chat Conversation' : 'Email Conversation'}</div>
						<div>
                            <span className={`${(conversation.session_id && conversation.session_id != 'null') ? styles.chatSession : styles.emailSession}`}>{(conversation.session_id && conversation.session_id != 'null') ? 'Chat' : 'Email'}</span>
                        </div>
						<div>{moment.tz(conversation.date_time, "UTC").format('MMMM DD, YYYY')}</div>
						<div className={`text-end ${conversation.is_processed ? styles.processed : styles.processing}`}>
							{
								conversation.is_processed ?
                                    isCurrentConversation ? '' : <Link to={`/${authCtx.currentTenant}/${URL.conversation}/${props.threadID}${sessionId}`}>View</Link>
                                    :
									`Processing...`
							}
						</div>
					</div>
				</li>

    })
    
    return (
        <div className={`modal fade ${styles.otherConversations}`} id="otherConversationsModal" data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog modal-dialog-centered" style={{maxWidth: '800px'}}>
                <div className="modal-content">
                    {
                        isLoading ?
                            <div className="d-flex justify-content-center my-5 p-2">
                                <Spinner size="md" />
                            </div> :
                            <>
                                {
                                    data?.conversations && data?.conversations?.length > 0 ?
                                        <>
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="deleteModalLabel">Conversations ({data.conversations.length})</h5>
                                                <button type="button" className={`${styles.closeModal} dismiss-otherConversationsModal`} onClick={props.cancelHandler} data-bs-dismiss="modal">&times;</button>
                                            </div>
                                            <div className="modal-body">
                                                <ul className={styles.sessionListItems}>
                                                    {list}
                                                </ul>
                                            </div>
                                        </>
                                        :
                                        (
                                            !isLoading && data?.ticket_id ?
                                                <h3 className="d-flex justify-content-center p-5">Ticket Not Found!</h3> :
                                                null
                                        )
                                }
                            </>
                    }
                    {
                        error ?
                            <h4 className="d-flex justify-content-center p-4">{ error }</h4>
                            :
                            null
                    }
                </div>
            </div>
        </div>
    )
}

export default OtherConversations
